/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

//import axios from '@/axios.js';
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/storage';
import moment from "moment-timezone";
import _ from 'lodash';
export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  
  async fetchAgents ({ commit }) {
    //const data = localStorage.getItem('userInfo');
    //const user = JSON.parse(data);
    /*if (user.company === undefined || user.company === '') {
      await firebase.auth().signOut().then(() => {
        router.push('/login').catch(() => {})
      });
    }*/
    const user = (await firebase.database().ref(`/users`).once('value')).val();
    const usersdata = [];
    for(const x in user){
      if(usersdata[user[x].agent] === undefined) {
        usersdata[user[x].agent] = 0;
      }
      usersdata[user[x].agent]++;
    }
    const master = (await firebase.database().ref(`/master`).once('value')).val();
    const masters = [];
    for(const x in master){
      if(masters[master[x].agent] === undefined) {
        masters[master[x].agent] = 0;
      }
      masters[master[x].agent]++;
    }
    firebase.database().ref().child('agents').once('value', (snapshot) => {
      let users = []; 
      snapshot.forEach((data) => {
        const user = data.val();
        user.key = data.key;
        user.master_count = (masters[data.key])?masters[data.key]:0;
        user.user_count = (usersdata[data.key])?usersdata[data.key]:0;
        let number = (Number(user.code*1));
        let digit = user.digit;
        if (number.toString().length > user.digit) {
          digit++;
          number = 1;
        }
        user.code = user.username+("000000000" + number).slice(-Number(digit));
        users.push(user);
      });
      users = _.orderBy(users, ['createdate'],['desc']);
      commit('SET_AGENTS', users);
    });
    //commit('SET_USERS', []);
  },
  saveAgent({state,commit,dispatch}){
    if(state.agent.key){
      console.log('update');
      let username = state.agent.username;
      if(username.toLowerCase().includes("ufs896")){
        username = username.toLowerCase().trim();
      }else{
        username = "ufs896"+username.toLowerCase().trim();
      }
      firebase.database().ref(`agents/${state.agent.key}`).update({
        name:state.agent.name,
        username,
        password:state.agent.password,
        createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss")
      });
    }else{
      let username = state.agent.username;
      console.log(username);
      if(username.toLowerCase().includes("ufs896")){
        username = username.toLowerCase().trim();
      }else{
        username = "ufs896"+username.toLowerCase().trim();
      }
      firebase.database().ref('agents').push({
        code:0,
        digit:3,
        name:state.agent.name,
        username,
        password:state.agent.password,
        createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss")
      });
    }
    dispatch('fetchAgents');
    commit('SET_AGENT',{
      key:'',
      digit:0,
      code:0,
      name:'',
      username:'',
      password:'',
    });
    commit('SET_POPUP',false);
  },
  updateUsers({state,commit}, {key,value}){
    console.log(key);
    console.log(value);
    console.log(state.users);
    const users = state.users;
    const keyUser = _.findKey(users, function(o) { return o.key === key; });
    if(keyUser){
      users.splice(keyUser, 1);
      value.key = key;
      users.splice(keyUser, 0, value);
      commit('SET_USERS', users);
    }
  },
}
